import { render, staticRenderFns } from "./MyTech.vue?vue&type=template&id=970a4be2&scoped=true"
import script from "./MyTech.vue?vue&type=script&lang=js"
export * from "./MyTech.vue?vue&type=script&lang=js"
import style0 from "./MyTech.vue?vue&type=style&index=0&id=970a4be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970a4be2",
  null
  
)

export default component.exports